"use client";

let gsapPromise: Promise<typeof import("gsap")["default"]> | null = null;
let scrollTriggerPromise: Promise<
	typeof import("gsap/ScrollTrigger")["ScrollTrigger"]
> | null = null;

export function loadGsap() {
	if (!gsapPromise) {
		gsapPromise = import("gsap").then((module) => module.default);
	}

	return gsapPromise;
}

export async function loadGsapWithScrollTrigger() {
	if (!scrollTriggerPromise) {
		scrollTriggerPromise = import("gsap/ScrollTrigger").then(
			(module) => module.ScrollTrigger,
		);
	}

	const [gsap, ScrollTrigger] = await Promise.all([
		loadGsap(),
		scrollTriggerPromise,
	]);

	gsap.registerPlugin(ScrollTrigger);

	return { gsap, ScrollTrigger };
}

export function canAnimatePointer() {
	if (typeof window === "undefined") {
		return false;
	}

	return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
}

export function shouldReduceMotion() {
	if (typeof window === "undefined") {
		return true;
	}

	return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
